/**
 * Production-safe logger - suppresses output in production builds
 * Replaces raw console.* calls throughout the app
 */
const isDev = process.env.NODE_ENV === 'development';

const logger = {
  log: isDev ? console.log.bind(console) : () => {},
  warn: isDev ? console.warn.bind(console) : () => {},
  error: isDev ? console.error.bind(console) : () => {},
};

export default logger;
